export default {
  COMMON_TAB_DATASET_BASIC_INFO: 'common.tab.datasetBasicInfo',
  COMMON_TAB_DATA_CATALOG: 'common.tab.dataCatalog',
  COMMON_TAB_METADATA_LIST: 'common.tab.metadataList',
  COMMON_TAB_DISPLAY_GALLERY: 'common.tab.displayGallery',
  COMMON_TAB_DISPLAY_TREE: 'common.tab.displayTree',
  COMMON_TAB_SUMMARY: 'common.tab.summary',
  COMMON_TAB_ATTACHED_FILE: 'common.tab.attachedFile',
  COMMON_TAB_FILE: 'common.tab.file',
  COMMON_BADGE_REQUIRED: 'common.badge.required',
  COMMON_BUTTON_CREATE_DATA_CATALOG: 'common.button.createDataCatalog',
  COMMON_BUTTON_OK: 'common.button.ok',
  COMMON_BUTTON_CANCEL: 'common.button.cancel',
  COMMON_BUTTON_CLOSE: 'common.button.close',
  COMMON_BUTTON_STOP: 'common.button.stop',
  COMMON_BUTTON_CANCEL_REGISTER: 'common.button.cancelRegister',
  COMMON_BUTTON_RETURN: 'common.button.return',
  COMMON_BUTTON_RESET: 'common.button.reset',
  COMMON_BUTTON_RESET_CANCEL: 'common.button.resetCancel',
  COMMON_BUTTON_NEXT: 'common.button.next',
  COMMON_BUTTON_SEND: 'common.button.send',
  COMMON_BUTTON_REMOVE: 'common.button.remove',
  COMMON_BUTTON_NEW_REGISTER: 'common.button.newRegister',
  COMMON_BUTTON_REGISTER: 'common.button.register',
  COMMON_BUTTON_EDIT: 'common.button.edit',
  COMMON_BUTTON_SELECT: 'common.button.select',
  COMMON_BUTTON_SEARCH: 'common.button.search',
  COMMON_BUTTON_FILE_SELECT: 'common.button.fileSelect',
  COMMON_BUTTON_FIX: 'common.button.fix',
  COMMON_BUTTON_ADD_ALIAS: 'common.button.addAlias',
  COMMON_BUTTON_ADD_SITE: 'common.button.addSite',
  COMMON_BUTTON_ADD_RELATED_INSTRUMENT_SITE: 'common.button.addRelatedInstrumentSite',
  COMMON_BUTTON_CONFIRM_REGISTER: 'common.button.confirmRegister',
  COMMON_BUTTON_LOGOUT: 'common.button.logout',
  COMMON_BUTTON_TOP: 'common.button.top',
  COMMON_BUTTON_SELECT_SAMPLE: 'common.button.selectSample',
  COMMON_BUTTON_SAVE: 'common.button.save',
  COMMON_BUTTON_DELETE_DATA: 'common.button.deleteData',
  COMMON_BUTTON_DOWNLOAD_DATA: 'common.button.downloadData',
  COMMON_BUTTON_BACK_TO_DATA_LIST: 'common.button.backToDataList',
  COMMON_BUTTON_DATASET_DELETE: 'common.button.datasetDelete',
  COMMON_BUTTON_DATA_LIST: 'common.button.dataList',
  COMMON_BUTTON_EDIT_INVOICE: 'common.button.editInvoice',
  COMMON_BUTTON_DISPLAY_DATA_LIST: 'common.button.displayDataList',
  COMMON_BUTTON_ADD: 'common.button.add',
  COMMON_BUTTON_UPDATE: 'common.button.update',
  COMMON_BUTTON_CANCEL_DATESET_CREATE: 'common.button.cancelDatesetCreate',
  COMMON_BUTTON_DATASET_RELEASE: 'common.button.datasetRelease',
  COMMON_BUTTON_ADD_RELATED_INFO: 'common.button.addRelatedInfo',
  COMMON_BUTTON_SHARE: 'common.button.share',
  COMMON_BUTTON_UNSHARE: 'common.button.unshare',
  COMMON_BUTTON_DATASET_RESTRUCTURE_SETTING: 'common.button.datasetRestructureSetting',
  COMMON_BUTTON_COPY_RESTRUCTURE_SETTING: 'common.button.copyRestructureSetting',
  COMMON_BUTTON_RESTRUCTURE: 'common.button.restructure',
  COMMON_BUTTON_CSV_DOWNLOAD: 'common.button.csvDownload',
  COMMON_LABEL_ATTACHED_FILE: 'common.label.attachedFile',
  COMMON_LABEL_FILE: 'common.label.file',
  COMMON_LABEL_HOW_TO_USE: 'common.label.howToUse',
  COMMON_LABEL_SEARCH_PARAMETERS: 'common.label.searchParameters',
  COMMON_LABEL_DATASET_TEMPLATE_NAME: 'common.label.datasetTemplateName',
  COMMON_LABEL_ORGANIZATION: 'common.label.organization',
  COMMON_LABEL_PROGRAM: 'common.label.program',
  COMMON_LABEL_INSTRUMENT_TERM_TYPE: 'common.label.instrumentTermType',
  COMMON_LABEL_LOCAL_ID: 'common.label.localId',
  COMMON_LABEL_UN_SELECTED: 'common.label.unSelected',
  COMMON_LABEL_INSTRUMENT_TERM_NAME: 'common.label.instrumentTermName',
  COMMON_LABEL_SEARCH_RESULT: 'common.label.searchResult',
  COMMON_LABEL_INSTRUMENT_AND_REGISTERED_NAME: 'common.label.instrumentAndRegisteredName',
  COMMON_LABEL_MANUFACTURE: 'common.label.manufacture',
  COMMON_LABEL_MODEL_NUMBER: 'common.label.modelNumber',
  COMMON_LABEL_PUBLIC_DETAIL: 'common.label.publicDetail',
  COMMON_LABEL_INSTRUMENT_ID: 'common.label.instrumentId',
  COMMON_LABEL_REGISTERED_NAME: 'common.label.registeredName',
  COMMON_LABEL_REGISTERED_NAME_JA: 'common.label.registeredNameJa',
  COMMON_LABEL_REGISTERED_NAME_EN: 'common.label.registeredNameEn',
  COMMON_LABEL_INSTRUMENT_ALIAS: 'common.label.instrumentAlias',
  COMMON_LABEL_INSTRUMENT_DESCRIPTION_JA: 'common.label.instrumentDescriptionJa',
  COMMON_LABEL_INSTRUMENT_DESCRIPTION_EN: 'common.label.instrumentDescriptionEn',
  COMMON_LABEL_MANUFACTURER_JA: 'common.label.manufacturerJa',
  COMMON_LABEL_MANUFACTURER_EN: 'common.label.manufacturerEn',
  COMMON_LABEL_PRODUCT_NAME: 'common.label.productName',
  COMMON_LABEL_RELATED_INSTRUMENT_INFO_SITE: 'common.label.relatedInstrumentInfoSite',
  COMMON_LABEL_MANAGEMENT_DETAIL: 'common.label.managementDetail',
  COMMON_LABEL_ORGANIZATION_LOCAL_ID: 'common.label.organizationLocalId',
  COMMON_LABEL_ASSET_NUMBER: 'common.label.assetNumber',
  COMMON_LABEL_FIXTURE_NUMBER: 'common.label.fixtureNumber',
  COMMON_LABEL_AVAILABLE_AREA: 'common.label.availableArea',
  COMMON_LABEL_LOCATION: 'common.label.location',
  COMMON_LABEL_BUILDING: 'common.label.building',
  COMMON_LABEL_ROOM: 'common.label.room',
  COMMON_LABEL_REMARK: 'common.label.remark',
  COMMON_LABEL_IOT_DEVICE_INFO: 'common.label.iotDeviceInfo',
  COMMON_LABEL_REGISTERED: 'common.label.registered',
  COMMON_LABEL_START_REGISTRATION_DATE: 'common.label.startRegistrationDate',
  COMMON_LABEL_MODIFIED: 'common.label.modified',
  COMMON_LABEL_ADMINISTRATOR_INFO: 'common.label.administratorInfo',
  COMMON_LABEL_INSTRUMENT_ADMINISTRATOR: 'common.label.instrumentAdministrator',
  COMMON_LABEL_INSTRUMENTS: 'common.label.instruments',
  COMMON_LABEL_INSTRUMENTS_GROUP: 'common.label.instrumentsGroup',
  COMMON_LABEL_DATA: 'common.label.data',
  COMMON_LABEL_DATA_LOWERCASE: 'common.label.dataLowercase',
  COMMON_LABEL_DATASET_FREE_INSTRUMENTS: 'common.label.datasetFreeInstruments',
  COMMON_LABEL_DATASET: 'common.label.dataset',
  COMMON_LABEL_DATASET_LOWERCASE: 'common.label.datasetLowercase',
  COMMON_LABEL_DATASET_OR_SAMPLE: 'common.label.datasetOrSample',
  COMMON_LABEL_DATASET_NAME: 'common.label.datasetName',
  COMMON_LABEL_TARGET_INSTRUMENTS: 'common.label.targetInstruments',
  COMMON_LABEL_DATASET_TYPE: 'common.label.datasetType',
  COMMON_LABEL_PROJECT_NUMBER_AND_NAME: 'common.label.projectNumberAndName',
  COMMON_LABEL_BASIC_INFO: 'common.label.basicInfo',
  COMMON_LABEL_ENTRY_DATE: 'common.label.entryDate',
  COMMON_LABEL_DATA_OPERATOR: 'common.label.dataOperator',
  COMMON_LABEL_DATA_OWNER_AND_AFFILIATION: 'common.label.dataOwnerAndAffiliation',
  COMMON_LABEL_DATA_NAME: 'common.label.dataName',
  COMMON_LABEL_EXPERIMENT_ID: 'common.label.experimentId',
  COMMON_LABEL_DESCRIPTION: 'common.label.description',
  COMMON_LABEL_SAMPLE: 'common.label.sample',
  COMMON_LABEL_SAMPLE_INFO: 'common.label.sampleInfo',
  COMMON_LABEL_SAMPLE_ID: 'common.label.sampleId',
  COMMON_LABEL_SAMPLE_NAME: 'common.label.sampleName',
  COMMON_LABEL_REFERENCE_URL: 'common.label.referenceUrl',
  COMMON_LABEL_SAMPLE_DESCRIPTION: 'common.label.sampleDescription',
  COMMON_LABEL_GENERIC_ITEM: 'common.label.genericItem',
  COMMON_LABEL_CATEGORIZED_ITEM: 'common.label.categorizedItem',
  COMMON_LABEL_FREE_ITEM: 'common.label.freeItem',
  COMMON_LABEL_UNIQUE_INFO: 'common.label.uniqueInfo',
  COMMON_LABEL_EXPERIMENT_DATA: 'common.label.experimentData',
  COMMON_LABEL_SAMPLE_REGISTER_FLAG: 'common.label.sampleRegisterFlag',
  COMMON_LABEL_FILE_NAME: 'common.label.fileName',
  COMMON_LABEL_FILE_REGISTERED_DATE: 'common.label.fileRegisteredDate',
  COMMON_LABEL_SIZE: 'common.label.size',
  COMMON_LABEL_CREATED: 'common.label.created',
  COMMON_LABEL_CHEMICAL_FORMULA: 'common.label.chemicalFormula',
  COMMON_LABEL_SAMPLE_ADMINISTRATOR: 'common.label.sampleAdministrator',
  COMMON_LABEL_RELATED_SAMPLE: 'common.label.relatedSample',
  COMMON_LABEL_TAG: 'common.label.tag',
  COMMON_LABEL_GROUP_NAME: 'common.label.groupName',
  COMMON_LABEL_ADMINISTRATOR: 'common.label.administrator',
  COMMON_LABEL_ADMINISTRATOR_AFFILIATION: 'common.label.administratorAffiliation',
  COMMON_LABEL_UPDATE: 'common.label.update',
  COMMON_LABEL_REGISTRATION_LIMIT: 'common.label.registrationLimit',
  COMMON_LABEL_DATA_QUANTITY: 'common.label.dataQuantity',
  COMMON_LABEL_DATA_TYPE: 'common.label.dataType',
  COMMON_LABEL_RAW_DATA_ATTRIBUTE: 'common.label.rawDataAttribute',
  COMMON_LABEL_RAW_DATA_STRUCTURE: 'common.label.rawDataStructure',
  COMMON_LABEL_OUTPUT_FILE_ATTRIBUTE: 'common.label.outputFileAttribute',
  COMMON_LABEL_REFERENCE_TREATISE: 'common.label.referenceTreatise',
  COMMON_LABEL_USER_NAME: 'common.label.userName',
  COMMON_LABEL_AFFILIATED_ORGANIZATION: 'common.label.affiliatedOrganization',
  COMMON_LABEL_SUMMARY: 'common.label.summary',
  COMMON_LABEL_META_INFO: 'common.label.metaInfo',
  COMMON_LABEL_CATEGORY: 'common.label.category',
  COMMON_LABEL_NAME_JA: 'common.label.nameJa',
  COMMON_LABEL_NAME_EN: 'common.label.nameEn',
  COMMON_LABEL_UNIT: 'common.label.unit',
  COMMON_LABEL_VALUE: 'common.label.value',
  COMMON_LABEL_ORDER_BY_ASC: 'common.label.orderByAsc',
  COMMON_LABEL_ORDER_BY_DESC: 'common.label.orderByDesc',
  COMMON_LABEL_PROJECT_NUMBER: 'common.label.projectNumber',
  COMMON_LABEL_DATA_LIST: 'common.label.dataList',
  COMMON_LABEL_PROJECT_NAME: 'common.label.projectName',
  COMMON_LABEL_DATASET_CREATOR: 'common.label.datasetCreator',
  COMMON_LABEL_EMBARGO_END_DATE: 'common.label.embargoEndDate',
  COMMON_LABEL_VERSION: 'common.label.version',
  COMMON_LABEL_GROUP: 'common.label.group',
  COMMON_LABEL_NO_CHANGE: 'common.label.noChange',
  COMMON_LABEL_DISCLOSURE_RANGE: 'common.label.disclosureRange',
  COMMON_LABEL_TAXONOMY: 'common.label.taxonomy',
  COMMON_LABEL_GROUP_MEMBER: 'common.label.groupMember',
  COMMON_LABEL_ROLE: 'common.label.role',
  COMMON_LABEL_GROUP_NAME_JA: 'common.label.groupNameJa',
  COMMON_LABEL_GROUP_NAME_EN: 'common.label.groupNameEn',
  COMMON_LABEL_DATA_OWNER: 'common.label.dataOwner',
  COMMON_LABEL_DOI: 'common.label.doi',
  COMMON_LABEL_RELEASE_NOTE: 'common.label.releaseNote',
  COMMON_LABEL_CREATE_DATASET: 'common.label.createDataset',
  COMMON_LABEL_DATASET_TYPE_CODE: 'common.label.datasetTypeCode',
  COMMON_LABEL_DATA_ENTRY_ID: 'common.label.dataEntryId',
  COMMON_LABEL_DATA_ENTRY_STATUS: 'common.label.dataEntryStatus',
  COMMON_LABEL_JOB_ID: 'common.label.jobId',
  COMMON_LABEL_ERROR_CODE: 'common.label.errorCode',
  COMMON_LABEL_ERROR_MESSAGE: 'common.label.errorMessage',
  COMMON_LABEL_TEAM_ADMINISTRATOR: 'common.label.teamAdministrator',
  COMMON_LABEL_TEAM_ADMINISTRATOR_PROXY: 'common.label.teamAdministratorProxy',
  COMMON_LABEL_TEAM_MEMBER: 'common.label.teamMember',
  COMMON_LABEL_DATA_REGISTER_PROXY: 'common.label.dataRegisterProxy',
  COMMON_LABEL_DATA_VIEWER: 'common.label.dataViewer',
  COMMON_LABEL_PROJECT: 'common.label.project',
  COMMON_LABEL_FUND_NUMBER: 'common.label.fundNumber',
  COMMON_LABEL_MEMBER_EDIT_AUTHORITY: 'common.label.memberEditAuthority',
  COMMON_LABEL_GROUP_INFO: 'common.label.groupInfo',
  COMMON_LABEL_DATASET_ID: 'common.label.datasetId',
  COMMON_LABEL_DATASET_DESCRIPTION: 'common.label.datasetDescription',
  COMMON_LABEL_RELATED_INFO: 'common.label.relatedInfo',
  COMMON_LABEL_RELATED_DATASET: 'common.label.relatedDataset',
  COMMON_LABEL_USING_LICENSE: 'common.label.usingLicense',
  COMMON_LABEL_DATASET_QUOTE_FORMAT: 'common.label.datasetQuoteFormat',
  COMMON_LABEL_CONTACT: 'common.label.contact',
  COMMON_LABEL_DATASET_TEMPLATE: 'common.label.datasetTemplate',
  COMMON_LABEL_BELONGING_TO: 'common.label.belongingTo',
  COMMON_LABEL_DATASET_ADMINISTRATOR_AND_AFFILIATION: 'common.label.datasetAdministratorAndAffiliation',
  COMMON_LABEL_RELEASE: 'common.label.release',
  COMMON_LABEL_MODIFIED_DATE_TIME: 'common.label.modifiedDateTime',
  COMMON_LABEL_STRUCTURED_DATA: 'common.label.structuredData',
  COMMON_LABEL_DATA_NUMBER: 'common.label.dataNumber',
  COMMON_LABEL_DATA_ID: 'common.label.dataId',
  COMMON_LABEL_URL_DESCRIPTION: 'common.label.urlDescription',
  COMMON_LABEL_TEMPLATE_NAME: 'common.label.templateName',
  COMMON_LABEL_CORRECT_EMAIL_ADDRESS: 'common.label.correctEmailAddress',
  COMMON_LABEL_HALF_WIDTH_CHARACTERS: 'common.label.halfWidthCharacters',
  COMMON_LABEL_CHARACTERS: 'common.label.characters',
  COMMON_LABEL_REMOVE: 'common.label.remove',
  COMMON_LABEL_STOP: 'common.label.stop',
  COMMON_LABEL_DATA_ENTRY: 'common.label.dataEntry',
  COMMON_LABEL_REGISTRATION_START_DATE_IN_JST: 'common.label.registrationStartDateInJst',
  COMMON_LABEL_REGISTRATION_START_DATE: 'common.label.registrationStartDate',
  COMMON_LABEL_URL: 'common.label.url',
  COMMON_LABEL_TITLE: 'common.label.title',
  COMMON_LABEL_UPLOADING: 'common.label.uploading',
  COMMON_LABEL_UPLOAD_COMPLETE: 'common.label.uploadComplete',
  COMMON_LABEL_UNEDITABLE: 'common.label.uneditable',
  COMMON_LABEL_CAN_CREATE_DATASETS: 'common.label.canCreateDatasets',
  COMMON_LABEL_CAN_EDIT_MEMBERS: 'common.label.canEditMembers',
  COMMON_LABEL_MAIL_ADDRESS: 'common.label.mailAddress',
  COMMON_LABEL_LESS_THAN: 'common.label.lessThan',
  COMMON_LABEL_MORE_THAN: 'common.label.moreThan',
  COMMON_LABEL_CORRECT_FORMAT: 'common.label.correctFormat',
  COMMON_LABEL_INTEGER: 'common.label.integer',
  COMMON_LABEL_RELATED_SAMPLE_DESCRIPTION: 'common.label.relatedSampleDescription',
  COMMON_LABEL_USER: 'common.label.user',
  COMMON_LABEL_INVOICE: 'common.label.invoice',
  COMMON_LABEL_SITE_NAME: 'common.label.siteName',
  COMMON_LABEL_VIRUS_SCAN_FILES: 'common.label.virusScanFiles',
  COMMON_LABEL_FILE_REGISTERED_DATE_TIME: 'common.label.fileRegisteredDateTime',
  COMMON_LABEL_FILE_REGISTRAR: 'common.label.fileRegistrar',
  COMMON_LABEL_VIRUS_SCAN_STATUS: 'common.label.virusScanStatus',
  COMMON_LABEL_FILE_TYPE_CODE: 'common.label.fileTypeCode',
  COMMON_LABEL_REGISTRATION_FILE: 'common.label.registrationFile',
  COMMON_LABEL_SHARED_RANGE: 'common.label.sharedRange',
  COMMON_LABEL_RDE_SHARED: 'common.label.rdeShared',
  COMMON_LABEL_RDE_ARIM_SHARED: 'common.label.rdeArimShared',
  COMMON_LABEL_RDE_CORE_SHARED: 'common.label.rdeCoreShared',
  COMMON_LABEL_PERMISSION_TO_VIEW: 'common.label.permissionToView',
  COMMON_LABEL_PERMISSION_DOWNLOAD: 'common.label.permissionDownload',
  COMMON_LABEL_STATUS: 'common.label.status',
  COMMON_LABEL_SHARING: 'common.label.sharing',
  COMMON_LABEL_NOT_SHARED: 'common.label.notShared',
  COMMON_LABEL_IS_ANONYMIZED: 'common.label.isAnonymized',
  COMMON_LABEL_SHARING_GROUPS: 'common.label.sharingGroups',
  COMMON_PLACEHOLDER_DATEPICKER: 'common.placeholder.datepicker',
  SCR_COM_1000_HEADER_TITLE: 'SCR-COM-1000.headerTitle',
  SCR_COM_1000__ABOUT_RDE_CONTACT: 'SCR-COM-1000.AboutRdeContact',
  SCR_COM_1000_NIMS: 'SCR-COM-1000.nims',
  SCR_COM_1000_MADIS: 'SCR-COM-1000.madis',
  SCR_COM_1000_DPFC: 'SCR-COM-1000.dpfc',
  SCR_COM_1000_PRIVACY_POLICY: 'SCR-COM-1000.privacyPolicy',
  SCR_COM_1000_ABOUT_GDPR: 'SCR-COM-1000.aboutGdpr',
  SCR_COM_1000_ABOUT_COOKIE: 'SCR-COM-1000.aboutCookie',
  SCR_COM_1000_CONTACT: 'SCR-COM-1000.contact',
  SCR_COM_1000_MATERIAL_DX: 'SCR-COM-1000.materialDx',
  SCR_COM_1000_MATERIAL_DX_USER: 'SCR-COM-1000.materialDxUser',
  SCR_COM_1000_NIMS_AND_JOINT_PROJECT: 'SCR-COM-1000.nimsAndJointProject',
  SCR_COM_1000_HERE: 'SCR-COM-1000.here',
  SCR_COM_1010_TITLE: 'SCR-COM-1010.title',
  SCR_COM_1010_HERE: 'SCR-COM-1010.here',
  SCR_COM_1010_BACK_TOP: 'SCR-COM-1010.backTop',
  SCR_DCV_1010_TITLE: 'SCR-DCV-1010.title',
  SCR_DCV_1010_GROUP_BROWSING_CREATE_DATASET: 'SCR-DCV-1010.groupBrowsingCreateDataset',
  SCR_DCV_1010_GROUP_BROWSING_CREATE_DATASET_BY_PROXY: 'SCR-DCV-1010.groupBrowsingCreateDatasetByProxy',
  SCR_DCV_1010_CREATED_DATA: 'SCR-DCV-1010.createdData',
  SCR_DCV_1010_CREATE_DATASET_BY_PROXY: 'SCR-DCV-1010.createDatasetByProxy',
  SCR_DCV_1010_SPECIFY_REQUIREMENT: 'SCR-DCV-1010.specifyRequirement',
  SCR_DCV_1010_LATEST_INFO: 'SCR-DCV-1010.latestInfo',
  SCR_DCV_1010_LATEST_MODIFIED_DATE: 'SCR-DCV-1010.latestModifiedDate',
  SCR_DCV_1010_CREATE_DATA: 'SCR-DCV-1010.createData',
  SCR_DCV_1010_CREATED_DATA_LIST: 'SCR-DCV-1010.createdDataList',
  SCR_DCV_1010_SEARCH_BY_KEY: 'SCR-DCV-1010.searchByKey',
  SCR_DCV_1010_SEARCH_KEY: 'SCR-DCV-1010.searchKey',
  SCR_DCV_1010_PUBLISHED: 'SCR-DCV-1010.published',
  SCR_DCV_1010_PLACEHOLDER_SEARCH_KEY: 'SCR-DCV-1010.placeholderSearchKey',
  SCR_DCV_1010_PLACEHOLDER_SEARCH_BY_KEY: 'SCR-DCV-1010.placeholderSearchByKey',
  SCR_DCV_1010_PLACEHOLDER_SOME_ITEMS: 'SCR-DCV-1010.placeholderSomeItems',
  SCR_DCV_1020_TITLE: 'SCR-DCV-1020.title',
  SCR_DCV_1020_USAGE_HISTORY: 'SCR-DCV-1020.usageHistory',
  SCR_DCV_1020_VIEWED: 'SCR-DCV-1020.viewed',
  SCR_DCV_1020_DOWNLOADED: 'SCR-DCV-1020.downloaded',
  SCR_DCV_1020_DATASET_SIZE: 'SCR-DCV-1020.datasetSize',
  SCR_DCV_1020_LICENSE: 'SCR-DCV-1020.license',
  SCR_DCV_1020_GENERAL: 'SCR-DCV-1020.general',
  SCR_DCV_1020_UN_RELEASED: 'SCR-DCV-1020.unReleased',
  SCR_DCV_1020_DISPLAYING_VERSION: 'SCR-DCV-1020.displayingVersion',
  SCR_DCV_1020_OPENED_DATE: 'SCR-DCV-1020.openedDate',
  SCR_DCV_1020_PUBLISHED_DATE: 'SCR-DCV-1020.publishedDate',
  SCR_DCV_1020_NO_PUBLISHED: 'SCR-DCV-1020.noPublished',
  SCR_DCV_1020_RELEASE_TIME: 'SCR-DCV-1020.releaseTime',
  SCR_DCV_1020_INDEFINITE_PERIOD: 'SCR-DCV-1020.indefinitePeriod',
  SCR_DCV_1020_DATA_ACCEPT: 'SCR-DCV-1020.dataAccept',
  SCR_DCV_1020_CHECKBOX_DESCRIPTION: 'SCR-DCV-1020.checkboxDescription',
  SCR_DCV_1031_PARAMETER_NAME: 'SCR-DCV-1031.parameterName',
  SCR_DCV_1031_COMMON_ITEMS: 'SCR-DCV-1031.commonItems',
  SCR_DCV_1031_MEASUREMENT_MODE_ITEM: 'SCR-DCV-1031.measurementModeItem',
  SCR_DCV_1040_TITLE: 'SCR-DCV-1040.title',
  SCR_DCV_1040_SORT_BY_PRIORITY: 'SCR-DCV-1040.sortByPriority',
  SCR_DCV_1040_ADD_ALL_DATASET: 'SCR-DCV-1040.addAllDataset',
  SCR_DCV_1040_PLACEHOLDER_DATASET_DESCRIPTION: 'SCR-DCV-1040.placeholderDatasetDescription',
  SCR_DCV_1040_PLACEHOLDER_DATASET_NAME: 'SCR-DCV-1040.placeholderDatasetName',
  SCR_DCV_1040_PLACEHOLDER_DATASET_MANAGER: 'SCR-DCV-1040.placeholderDatasetManager',
  SCR_DCV_1040_PLACEHOLDER_TITLE: 'SCR-DCV-1040.placeholderTitle',
  SCR_DCV_1040_PLACEHOLDER_URL: 'SCR-DCV-1040.placeholderUrl',
  SCR_DCV_1040_PLACEHOLDER_DATASET_OR_ID: 'SCR-DCV-1040.placeholderDatasetOrId',
  SCR_DCV_1040_PLACEHOLDER_SELECT_USING_LICENSE: 'SCR-DCV-1040.placeholderSelectUsingLicense',
  SCR_DCV_1040_PLACEHOLDER_DATASET_QUOTE_FORMAT: 'SCR-DCV-1040.placeholderDatasetQuoteFormat',
  SCR_DCV_1040_PLACEHOLDER_CONTACT: 'SCR-DCV-1040.placeholderContact',
  SCR_DCV_1040_PLACEHOLDER_ENTER_DATASET_CODE: 'SCR-DCV-1040.placeholderEnterDatasetCode',
  SCR_DCV_1040_PLACEHOLDER_VERSION_NAME: 'SCR-DCV-1040.placeholderVersionName',
  SCR_DCV_1040_PLACEHOLDER_DOI: 'SCR-DCV-1040.placeholderDoi',
  SCR_DCV_1040_PLACEHOLDER_RELEASE_NOTE: 'SCR-DCV-1040.placeholderReleaseNote',
  SCR_DCV_1040_PLACEHOLDER_SELECT_PROJECT_NUMBER: 'SCR-DCV-1040.placeholderSelectProjectNumber',
  SCR_DCV_1040_PLACEHOLDER_GROUP_ID: 'SCR-DCV-1040.placeholderGroupId',
  SCR_DCV_1040_PLACEHOLDER_GROUP_NAME: 'SCR-DCV-1040.placeholderGroupName',
  SCR_DCV_1040_NOTE_ON_DATESET_SHARING_GROUP: 'SCR-DCV-1040.noteOnDatesetSharingGroup',
  SCR_DCV_1040_NOTE: 'SCR-DCV-1040.note',
  SCR_DCV_1040_NOTE_ON_ANONIMIZED: 'SCR-DCV-1040.noteOnAnonimized',
  SCR_DCV_1040_DATA_ACCEPT: 'SCR-DCV-1040.dataAccept',
  SCR_DCV_1040_CHECKBOX_DESCRIPTION: 'SCR-DCV-1040.checkboxDescription',
  SCR_DCV_1041_TITLE: 'SCR-DCV-1041.title',
  SCR_DCV_1041_DIGIT: 'SCR-DCV-1041.digit',
  SCR_DCV_1070_TITLE: 'SCR-DCV-1070.title',
  SCR_DCV_1070_PLACEHOLDER_DATASET_NAME: 'SCR-DCV-1070.placeholderDatasetName',
  SCR_DCV_1090_TITLE: 'SCR-DCV-1090.title',
  SCR_DCV_1090_PLACEHOLDER_VERSION: 'SCR-DCV-1090.placeholderVersion',
  SCR_DCV_1090_PLACEHOLDER_DOI: 'SCR-DCV-1090.placeholderDoi',
  SCR_DCV_1090_PLACEHOLDER_RELEASE_NOTE: 'SCR-DCV-1090.placeholderReleaseNote',
  SCR_DCV_1100_TITLE: 'SCR-DCV-1100.title',
  SCR_DCV_1100_BUTTON_DATASET_LIST: 'SCR-DCV-1100.button.datasetList',
  SCR_DCV_1100_PLACEHOLDER_SEARCH_BY_KEY: 'SCR-DCV-1100.placeholderSearchByKey',
  SCR_DCV_1100_LABEL_KEY_VALUE_SEARCH: 'SCR-DCV-1100.label.keyValueSearch',
  SCR_DCV_1100_LABEL_KEY_VALUE_SEARCH_JOIN: 'SCR-DCV-1100.label.keyValueSearchJoin',
  SCR_DCV_1100_LABEL_KEY: 'SCR-DCV-1100.label.key',
  SCR_DCV_1100_LABEL_SEARCH_VALUE: 'SCR-DCV-1100.label.searchValue',
  SCR_DCV_1100_LABEL_CHAR_STRING: 'SCR-DCV-1100.label.charString',
  SCR_DCV_1100_LABEL_NUMBER: 'SCR-DCV-1100.label.number',
  SCR_DCV_1100_LABEL_DATE: 'SCR-DCV-1100.label.date',
  SCR_DCV_1100_PLACEHOLDER_KEY: 'SCR-DCV-1100.placeholderKey',
  SCR_DCV_1100_PLACEHOLDER_VALUE: 'SCR-DCV-1100.placeholderValue',
  SCR_DCV_1100_PLACEHOLDER_UNIT: 'SCR-DCV-1100.placeholderUnit',
  SCR_DCV_1100_BUTTON_CONDITION: 'SCR-DCV-1100.button.condition',
  SCR_DCV_1100_LABEL_SEARCH_TARGET: 'SCR-DCV-1100.label.searchTarget',
  SCR_DCV_1100_LABEL_SEARCH_DESCRIPTION: 'SCR-DCV-1100.label.searchDescription',
  SCR_DCV_1100_LABEL_SHARE_DATE_AND_TIME: 'SCR-DCV-1100.label.shareDateAndTime',
  SCR_DCV_1100_LABEL_SAMPLE_NAME: 'SCR-DCV-1100.label.sampleName',
  SCR_DCV_1100_LABEL_DESCRIPTION: 'SCR-DCV-1100.label.description',
  SCR_DCV_1100_LABEL_DATA_REGISTRATION_DATE: 'SCR-DCV-1100.label.dataRegistrationDate',
  SCR_DCV_1100_BUTTON_DOWNLOADED: 'SCR-DCV-1100.button.downloaded',
  SCR_DCV_1110_TITLE: 'SCR-DCV-1110.title',
  SCR_DCV_1110_CURRENT_DATASET_TEMPLATE: 'SCR-DCV-1110.currentDatasetTemplate',
  SCR_DCV_1110_APPLY_DATASET_TEMPLATE: 'SCR-DCV-1110.applyDatasetTemplate',
  SCR_DCV_1110_EXIST: 'SCR-DCV-1110.exist',
  SCR_DCV_1110_NONE: 'SCR-DCV-1110.none',
  SCR_DCV_1120_TITLE: 'SCR-DCV-1120.title',
  SCR_DCV_1130_TITLE: 'SCR-DCV-1130.title',
  SCR_DCV_1130_DATASET_RESTRUCTURE: 'SCR-DCV-1130.datasetRestructure',
  SCR_DCV_1130_CSV_RESTRUCTURE: 'SCR-DCV-1130.csvRestructure',
  SCR_DCV_1130_DATASET_RESTRUCTURE_DESCRIPTION: 'SCR-DCV-1130.datasetRestructureDescription',
  SCR_DCV_1130_CSV_RESTRUCTURE_DESCRIPTION: 'SCR-DCV-1130.csvRestructureDescription',
  SCR_DCV_1130_CSV_FILE_CHECK_RESULT: 'SCR-DCV-1130.csvFileCheckResult',
  SCR_DCV_1130_PLACEHOLDER_DATASET_ID: 'SCR-DCV-1130.placeholderDatasetId',
  SCR_DCV_1130_PLACEHOLDER_DATASET_NAME: 'SCR-DCV-1130.placeholderDatasetName',
  SCR_DCV_1130_PLACEHOLDER_CSV_FILE_CHECK_RESULT: 'SCR-DCV-1130.placeholderCsvFileCheckResult',
  SCR_DCV_1130_UN_RELEASED: 'SCR-DCV-1130.unReleased',
  SCR_DCV_1200_TITLE: 'SCR-DCV-1200.title',
  SCR_DCV_1200_DATASET_SUMMARY: 'SCR-DCV-1200.datasetSummary',
  SCR_DCV_1200_DATASET_DETAIL: 'SCR-DCV-1200.datasetDetail',
  SCR_DCV_1200_BACK_DATASET_LIST: 'SCR-DCV-1200.backDatasetList',
  SCR_DCV_1200_PLACEHOLDER_DATA_NAME: 'SCR-DCV-1200.placeholderDataName',
  SCR_DCV_1200_PLACEHOLDER_DATA_NUMBER: 'SCR-DCV-1200.placeholderDataNumber',
  SCR_DCV_1200_PLACEHOLDER_SAMPLE_NAME: 'SCR-DCV-1200.placeholderSampleName',
  SCR_DCV_1200_PLACEHOLDER_DATA_OWNER: 'SCR-DCV-1200.placeholderDataOwner',
  SCR_DCV_1200_PLACEHOLDER_TAXONOMY: 'SCR-DCV-1200.placeholderTaxonomy',
  SCR_DCV_1200_PLACEHOLDER_DESCRIPTION: 'SCR-DCV-1200.placeholderDescription',
  SCR_DCV_1200_PLACEHOLDER_TAXONOMY_KEY: 'SCR-DCV-1200.placeholderTaxonomyKey',
  SCR_DCV_1210_TITLE: 'SCR-DCV-1210.title',
  SCR_DCV_1210_THUMBNAIL_DESCRIPTION: 'SCR-DCV-1210.thumbnailDescription',
  SCR_DCV_1210_META_INFO_DESCRIPTION: 'SCR-DCV-1210.metaInfoDescription',
  SCR_DCV_1210_INSTRUMENTS_INFO: 'SCR-DCV-1210.instrumentsInfo',
  SCR_DCV_1210_DOWNLOADING: 'SCR-DCV-1210.downloading',
  SCR_DCV_1220_FILE_TYPE_CODE: 'SCR-DCV-1220.fileTypeCode',
  SCR_DCV_1230_TITLE: 'SCR-DCV-1230.title',
  SCR_DCV_1230_SAMPLE_MANAGER_ANONYMIZED: 'SCR-DCV-1230.sampleManagerAnonymized',
  SCR_DCV_1230_PLACEHOLDER_DESCRIPTION: 'SCR-DCV-1230.placeholderDescription',
  SCR_DCV_1230_PLEASE_DRAG_ATTACHED_FILE: 'SCR-DCV-1230.pleaseDragAttachedFile',
  SCR_DCV_1230_PLACEHOLDER_DATA_NAME: 'SCR-DCV-1230.placeholderDataName',
  SCR_DCV_1230_PLACEHOLDER_EXPERIMENT_ID: 'SCR-DCV-1230.placeholderExperimentId',
  SCR_DCV_1230_PLACEHOLDER_SAMPLE_NAME: 'SCR-DCV-1230.placeholderSampleName',
  SCR_DCV_1230_PLACEHOLDER_SAMPLE_ADMINISTRATOR: 'SCR-DCV-1230.placeholderSampleAdministrator',
  SCR_DCV_1230_PLACEHOLDER_REFERENCE_URL: 'SCR-DCV-1230.placeholderReferenceUrl',
  SCR_DCV_1230_PLACEHOLDER_SAMPLE_DESCRIPTION_OR_HISTORY: 'SCR-DCV-1230.placeholderSampleDescriptionOrHistory',
  SCR_DCV_1230_PLACEHOLDER_ENTER_CHEMICAL_FORMULA: 'SCR-DCV-1230.placeholderEnterChemicalFormula',
  SCR_DCV_1250_TITLE: 'SCR-DCV-1250.title',
  SCR_DCV_1280_TITLE: 'SCR-DCV-1280.title',
  SCR_DCV_2010_TITLE: 'SCR-DCV-2010.title',
  SCR_DCV_2010_PLACEHOLDER_SELECT_PROGRAM: 'SCR-DCV-2010.placeholderSelectProgram',
  SCR_DCV_2010_PLACEHOLDER_SELECT_DATASET_TYPE_CODE: 'SCR-DCV-2010.placeholderSelectDatasetTypeCode',
  SCR_DCV_2020_TITLE: 'SCR-DCV-2020.title',
  SCR_DCV_2020_TITLE_AGENT: 'SCR-DCV-2020.titleAgent',
  SCR_DCV_2020_NONE_PRIVATE: 'SCR-DCV-2020.nonePrivate',
  SCR_DCV_2020_EXIST: 'SCR-DCV-2020.exist',
  SCR_DCV_2020_NONE: 'SCR-DCV-2020.none',
  SCR_DCV_2020_ADDITIONAL_SETTING: 'SCR-DCV-2020.additionalSetting',
  SCR_DCV_2020_AFTER_THE_EMBARGO_SHARED: 'SCR-DCV-2020.afterTheEmbargoShared',
  SCR_DCV_2020_RDE_SHARED: 'SCR-DCV-2020.rdeShared',
  SCR_DCV_2020_RDE_ARIM_SHARED: 'SCR-DCV-2020.rdeArimShared',
  SCR_DCV_2020_RDE_CORE_SHARED: 'SCR-DCV-2020.rdeCoreShared',
  SCR_DCV_2020_AFTER_THE_EMBARGO_NOT_DISCLOSED: 'SCR-DCV-2020.afterTheEmbargoNotDisclosed',
  SCR_DCV_2020_DATASET_CREATOR: 'SCR-DCV-2020.datasetCreator',
  SCR_DCV_2020_DATASET_MANAGER: 'SCR-DCV-2020.datasetManager',
  SCR_DCV_2020_SUBJECT_NUMBER_AND_SUBJECT_TITLE: 'SCR-DCV-2020.subjectNumberAndSubjectTitle',
  SCR_DCV_2020_DATA_OWNER: 'SCR-DCV-2020.dataOwner',
  SCR_DCV_2020_PLACEHOLDER_SELECT_PROJECT_NUMBER: 'SCR-DCV-2020.placeholderSelectProjectNumber',
  SCR_DCV_2020_PLACEHOLDER_DATASET_NAME: 'SCR-DCV-2020.placeholderDatasetName',
  SCR_DCV_2020_PLACEHOLDER_DATASET_MANAGER: 'SCR-DCV-2020.placeholderDatasetManager',
  SCR_DCV_2050_TITLE: 'SCR-DCV-2050.title',
  SCR_DCV_2050_TITLE_AGENT: 'SCR-DCV-2050.titleAgent',
  SCR_DCV_2050_CREATE_DATASET: 'SCR-DCV-2050.createDataset',
  SCR_DCV_4010_PLACEHOLDER_DATASET_NAME: 'SCR-DCV-4010.placeholderDatasetName',
  SCR_DCV_4010_PLACEHOLDER_PROJECT_NUMBER: 'SCR-DCV-4010.placeholderProjectNumber',
  SCR_DCV_4010_PLACEHOLDER_PROJECT_NAME: 'SCR-DCV-4010.placeholderProjectName',
  SCR_DCV_4010_TITLE: 'SCR-DCV-4010.title',
  SCR_DCV_4010_DATASET_ADMINISTRATOR: 'SCR-DCV-4010.datasetAdministrator',
  SCR_DCV_4010_TARGET_INSTRUMENTS_NAME: 'SCR-DCV-4010.targetInstrumentsName',
  SCR_DCV_4020_PLACEHOLDER_SAMPLE_DESCRIPTION_OR_HISTORY: 'SCR-DCV-4020.placeholderSampleDescriptionOrHistory',
  SCR_DCV_4020_PLACEHOLDER_SELECT_INSTRUMENTS: 'SCR-DCV-4020.placeholderSelectInstruments',
  SCR_DCV_4020_PLACEHOLDER_DATA_OWNER: 'SCR-DCV-4020.placeholderDataOwner',
  SCR_DCV_4020_PLACEHOLDER_DATA_NAME: 'SCR-DCV-4020.placeholderDataName',
  SCR_DCV_4020_PLACEHOLDER_EXPERIMENT_ID: 'SCR-DCV-4020.placeholderExperimentId',
  SCR_DCV_4020_PLACEHOLDER_DESCRIPTION: 'SCR-DCV-4020.placeholderDescription',
  SCR_DCV_4020_PLACEHOLDER_SAMPLE_NAME_OR_ID: 'SCR-DCV-4020.placeholderSampleNameOrId',
  SCR_DCV_4020_PLACEHOLDER_SAMPLE_ADMINISTRATOR: 'SCR-DCV-4020.placeholderSampleAdministrator',
  SCR_DCV_4020_PLACEHOLDER_REFERENCE_URL: 'SCR-DCV-4020.placeholderReferenceUrl',
  SCR_DCV_4020_PLACEHOLDER_ENTER_CHEMICAL_FORMULA: 'SCR-DCV-4020.placeholderEnterChemicalFormula',
  SCR_DCV_4020_TITLE: 'SCR-DCV-4020.title',
  SCR_DCV_4020_PLEASE_DRAG_EXPERIMENT_DATA: 'SCR-DCV-4020.pleaseDragExperimentData',
  SCR_DCV_4020__REGISTER_FILE: 'SCR-DCV-4020.RegisterFile',
  SCR_DCV_4020_PLEASE_DRAG_REGISTER_FILE: 'SCR-DCV-4020.pleaseDragRegisterFile',
  SCR_DCV_4020__ATTACHED_FILE: 'SCR-DCV-4020.AttachedFile',
  SCR_DCV_4020_PLEASE_DRAG_ATTACHED_FILE: 'SCR-DCV-4020.pleaseDragAttachedFile',
  SCR_DCV_4020_CONTENT_CONFIRMATION: 'SCR-DCV-4020.contentConfirmation',
  SCR_DCV_4020_SAMPLE_MANAGER_ANONYMIZED: 'SCR-DCV-4020.sampleManagerAnonymized',
  SCR_DCV_4030_TITLE: 'SCR-DCV-4030.title',
  SCR_DCV_4020_SAMPLE_MANAGER_NOT_ANONYMIZED: 'SCR-DCV-4020.sampleManagerNotAnonymized',
  SCR_DCV_4030_START_REGISTRATION: 'SCR-DCV-4030.startRegistration',
  SCR_DCV_4030_REGISTER_CONTINUOUSLY: 'SCR-DCV-4030.registerContinuously',
  SCR_DCV_4100_TITLE: 'SCR-DCV-4100.title',
  SCR_DCV_4100_REGISTERED_DATE: 'SCR-DCV-4100.registeredDate',
  SCR_DCV_4100_STATUS: 'SCR-DCV-4100.status',
  SCR_DCV_4100_DATA_OPERATOR: 'SCR-DCV-4100.dataOperator',
  SCR_DCV_4100_PLACEHOLDER_DATA_NAME: 'SCR-DCV-4100.placeholderDataName',
  SCR_DCV_4100_PLACEHOLDER_SELECT_STATUS: 'SCR-DCV-4100.placeholderSelectStatus',
  SCR_DCV_4100_PLACEHOLDER_DATASET_NAME: 'SCR-DCV-4100.placeholderDatasetName',
  SCR_DCV_4110_TITLE: 'SCR-DCV-4110.title',
  SCR_DCV_4110_RESTRUCTURE_DOWNLOAD: 'SCR-DCV-4110.restructureDownload',
  SCR_DCV_4120_TITLE: 'SCR-DCV-4120.title',
  SCR_DCV_5020_TITLE: 'SCR-DCV-5020.title',
  SCR_DCV_5020_PLACEHOLDER_GROUP_NAME_JA: 'SCR-DCV-5020.placeholderGroupNameJa',
  SCR_DCV_5020_PLACEHOLDER_GROUP_NAME_EN: 'SCR-DCV-5020.placeholderGroupNameEn',
  SCR_DCV_5020_PLACEHOLDER_DESCRIPTION: 'SCR-DCV-5020.placeholderDescription',
  SCR_DCV_5020_PLACEHOLDER_MAIL_ADDRESS_OF_MEMBER: 'SCR-DCV-5020.placeholderMailAddressOfMember',
  SCR_DCV_5020_PLACEHOLDER_PROJECT_NUMBER: 'SCR-DCV-5020.placeholderProjectNumber',
  SCR_DCV_5020_PLACEHOLDER_PROJECT_NAME: 'SCR-DCV-5020.placeholderProjectName',
  SCR_DCV_5020_PLACEHOLDER_FUND_NUMBER: 'SCR-DCV-5020.placeholderFundNumber',
  SCR_DCV_5020_PLACEHOLDER_GROUP_NAME: 'SCR-DCV-5020.placeholderGroupName',
  SCR_DCV_5030_TITLE: 'SCR-DCV-5030.title',
  SCR_DCV_5030_ALL_PROGRAM: 'SCR-DCV-5030.allProgram',
  SCR_DCV_5030_GROUP_ID: 'SCR-DCV-5030.groupId',
  SCR_DCV_5030_SUB_GROUP: 'SCR-DCV-5030.subGroup',
  SCR_DCV_5030_HEADER_CAN_EDIT_MEMBER: 'SCR-DCV-5030.headerCanEditMember',
  SCR_DCV_5030_CREATE_SUB_GROUP: 'SCR-DCV-5030.createSubGroup',
  SCR_DCV_5030_NONE: 'SCR-DCV-5030.none',
  SCR_DCV_5030_UNSELECTED: 'SCR-DCV-5030.unselected',
  SCR_DCV_5030_BUTTON_CSV_IMPORT: 'SCR-DCV-5030.buttonCsvImport',
  SCR_DCV_5030_CSV_IMPORT_RESULT: 'SCR-DCV-5030.csvImportResult',
  SCR_DCV_5030_PLACEHOLDER_CSV_IMPORT_RESULT: 'SCR-DCV-5030.placeholderCsvImportResult',
  SCR_DCV_5030_PLACEHOLDER_SEARCH_GROUP_NAME: 'SCR-DCV-5030.placeholderSearchGroupName',
  SCR_DCV_5030_CREATE_DATASET: 'SCR-DCV-5030.createDataset',
  SCR_DCV_5035_TITLE: 'SCR-DCV-5035.title',
  SCR_DCV_5035_PLACEHOLDER_GROUP_NAME: 'SCR-DCV-5035.placeholderGroupName',
  SCR_DCV_5040_TITLE: 'SCR-DCV-5040.title',
  SCR_DCV_5040_DATASET_MANAGER: 'SCR-DCV-5040.datasetManager',
  SCR_DCV_5040_SAMPLE_ADMINISTRATOR: 'SCR-DCV-5040.sampleAdministrator',
  SCR_DCV_5040_DATA_OWNER: 'SCR-DCV-5040.dataOwner',
  SCR_DCV_5050_TITLE: 'SCR-DCV-5050.title',
  SCR_DCV_5050_PLACEHOLDER_GROUP_NAME: 'SCR-DCV-5050.placeholderGroupName',
  SCR_INS_1010_TITLE: 'SCR-INS-1010.title',
  SCR_INS_1010_PLACEHOLDER_SELECT_ORGANIZATION: 'SCR-INS-1010.placeholderSelectOrganization',
  SCR_INS_1010_PLACEHOLDER_SELECT_PROGRAM: 'SCR-INS-1010.placeholderSelectProgram',
  SCR_INS_1010_PLACEHOLDER_VALID_INSTRUMENT_ID: 'SCR-INS-1010.placeholderValidInstrumentId',
  SCR_INS_1010_PLACEHOLDER_INSTRUMENTS: 'SCR-INS-1010.placeholderInstruments',
  SCR_INS_1020_TITLE: 'SCR-INS-1020.title',
  SCR_INS_1030_TITLE: 'SCR-INS-1030.title',
  SCR_INS_1030_PLACEHOLDER_VALID_INSTRUMENT_ID: 'SCR-INS-1030.placeholderValidInstrumentId',
  SCR_INS_1030_PLACEHOLDER_SELECT_ADD_PROGRAM: 'SCR-INS-1030.placeholderSelectAddProgram',
  SCR_INS_1030_PLACEHOLDER_REGISTERED_NAME_JA: 'SCR-INS-1030.placeholderRegisteredNameJa',
  SCR_INS_1030_PLACEHOLDER_REGISTERED_NAME_EN: 'SCR-INS-1030.placeholderRegisteredNameEn',
  SCR_INS_1030_PLACEHOLDER_MODEL_NUMBER: 'SCR-INS-1030.placeholderModelNumber',
  SCR_INS_1030_PLACEHOLDER_ALIAS: 'SCR-INS-1030.placeholderAlias',
  SCR_INS_1030_PLACEHOLDER_INSTRUMENT_DESCRIPTION_JA: 'SCR-INS-1030.placeholderInstrumentDescriptionJa',
  SCR_INS_1030_PLACEHOLDER_INSTRUMENT_DESCRIPTION_EN: 'SCR-INS-1030.placeholderInstrumentDescriptionEn',
  SCR_INS_1030_PLACEHOLDER_MANUFACTURER_JA: 'SCR-INS-1030.placeholderManufacturerJa',
  SCR_INS_1030_PLACEHOLDER_MANUFACTURER_EN: 'SCR-INS-1030.placeholderManufacturerEn',
  SCR_INS_1030_PLACEHOLDER_PRODUCT_NAME: 'SCR-INS-1030.placeholderProductName',
  SCR_INS_1030_PLACEHOLDER_TITLE: 'SCR-INS-1030.placeholderTitle',
  SCR_INS_1030_PLACEHOLDER_URL: 'SCR-INS-1030.placeholderUrl',
  SCR_INS_1030_PLACEHOLDER_ORGANIZATION_LOCAL_ID: 'SCR-INS-1030.placeholderOrganizationLocalId',
  SCR_INS_1030_PLACEHOLDER_ASSET_NUMBER: 'SCR-INS-1030.placeholderAssetNumber',
  SCR_INS_1030_PLACEHOLDER_FIXTURE_NUMBER: 'SCR-INS-1030.placeholderFixtureNumber',
  SCR_INS_1030_PLACEHOLDER_LOCATION: 'SCR-INS-1030.placeholderLocation',
  SCR_INS_1030_PLACEHOLDER_BUILDING: 'SCR-INS-1030.placeholderBuilding',
  SCR_INS_1030_PLACEHOLDER_ROOM: 'SCR-INS-1030.placeholderRoom',
  SCR_INS_1030_PLACEHOLDER_REMARK: 'SCR-INS-1030.placeholderRemark',
  SCR_INS_1030_PLACEHOLDER_IOT_DEVICE_INFO: 'SCR-INS-1030.placeholderIotDeviceInfo',
  SCR_INS_1030_PLACEHOLDER_MAIL_ADDRESS: 'SCR-INS-1030.placeholderMailAddress',
  SCR_INS_1040_TITLE: 'SCR-INS-1040.title',
  SCR_INS_1050_TITLE: 'SCR-INS-1050.title',
  SCR_INS_2010_PLACEHOLDER_SELECT_ORGANIZATION: 'SCR-INS-2010.placeholderSelectOrganization',
  SCR_INS_2010_PLACEHOLDER_SELECT_PROGRAM: 'SCR-INS-2010.placeholderSelectProgram',
  SCR_INS_2010_PLACEHOLDER_VALID_INSTRUMENT_ID: 'SCR-INS-2010.placeholderValidInstrumentId',
  SCR_INS_2010_PLACEHOLDER_INSTRUMENTS_NAME: 'SCR-INS-2010.placeholderInstrumentsName',
  SCR_INS_2010_TITLE: 'SCR-INS-2010.title',
  SCR_SMP_1010_TITLE: 'SCR-SMP-1010.title',
  SCR_SMP_1010_PLACEHOLDER_CHEMICAL_FORMULA: 'SCR-SMP-1010.placeholderChemicalFormula',
  SCR_SMP_1020_TITLE: 'SCR-SMP-1020.title',
  SCR_SMP_1020_SHARING_GROUPS_INFO: 'SCR-SMP-1020.sharingGroupsInfo',
  SCR_SMP_1030_TITLE: 'SCR-SMP-1030.title',
  SCR_SMP_1030_INPUT_SAMPLE_INFO: 'SCR-SMP-1030.inputSampleInfo',
  SCR_SMP_1030_INPUT_SHARING_GROUP_INFO: 'SCR-SMP-1030.inputSharingGroupInfo',
  SCR_SMP_1030_PLACEHOLDER_SAMPLE_NAME_OR_ID: 'SCR-SMP-1030.placeholderSampleNameOrId',
  SCR_SMP_1030_PLACEHOLDER_ENTER_CHEMICAL_FORMULA: 'SCR-SMP-1030.placeholderEnterChemicalFormula',
  SCR_DCV_1030_PLACEHOLDER_SAMPLE_ADMINISTRATOR: 'SCR-DCV-1030.placeholderSampleAdministrator',
  SCR_SMP_1030_PLACEHOLDER_REFERENCE_URL: 'SCR-SMP-1030.placeholderReferenceUrl',
  SCR_SMP_1030_PLACEHOLDER_TAG: 'SCR-SMP-1030.placeholderTag',
  SCR_SMP_1030_PLACEHOLDER_DESCRIPTION: 'SCR-SMP-1030.placeholderDescription',
  SCR_SMP_1030_PLACEHOLDER_ITEM_NAME: 'SCR-SMP-1030.placeholderItemName',
  SCR_SMP_1030_PLACEHOLDER_ITEM_SET_VALUE: 'SCR-SMP-1030.placeholderItemSetValue',
  SCR_SMP_1030_PLACEHOLDER_GENERIC_ITEM: 'SCR-SMP-1030.placeholderGenericItem',
  SCR_SMP_1030_PLACEHOLDER_CATEGORIZED_ITEM: 'SCR-SMP-1030.placeholderCategorizedItem',
  SCR_SMP_1030_PLACEHOLDER_CATEGORIZED_ITEM_DETAIL: 'SCR-SMP-1030.placeholderCategorizedItemDetail',
  SCR_SMP_1030_ADD_SAMPLE_NAME: 'SCR-SMP-1030.addSampleName',
  SCR_SMP_1030_ADD_RELATED_SAMPLE: 'SCR-SMP-1030.addRelatedSample',
  SCR_SMP_1030_PLACEHOLDER_SAMPLE_ADMINISTRATOR: 'SCR-SMP-1030.placeholderSampleAdministrator',
  SCR_SMP_1030_PLACEHOLDER_SAMPLE_DESCRIPTION_OR_HISTORY: 'SCR-SMP-1030.placeholderSampleDescriptionOrHistory',
  SCR_SMP_1030_PLACEHOLDER_VALUE: 'SCR-SMP-1030.placeholderValue',
  SCR_SMP_1030_PLACEHOLDER_GROUP_ID: 'SCR-SMP-1030.placeholderGroupId',
  SCR_SMP_1030_PLACEHOLDER_GROUP_NAME: 'SCR-SMP-1030.placeholderGroupName',
  SCR_SMP_1030_LABEL_OTHER_SAMPLE: 'SCR-SMP-1030.labelOtherSample',
  SCR_SMP_1030_SAMPLE_MANAGER_ANONYMIZED: 'SCR-SMP-1030.sampleManagerAnonymized',
  SCR_SMP_1030_NOTE_ON_SAMPLE_SHARING_GROUP: 'SCR-SMP-1030.noteOnSampleSharingGroup',
  SCR_SMP_1030_NOTE: 'SCR-SMP-1030.note',
  SCR_SMP_1030_SHARING_GROUPS_INFO: 'SCR-SMP-1030.sharingGroupsInfo',
  SCR_SMP_1030_SAMPLE_SHARING_GROUP_CONFIRMATION: 'SCR-SMP-1030.sampleSharingGroupConfirmation',
  SCR_SMP_1030_MATCHING_GROUP: 'SCR-SMP-1030.matchingGroup',
  SCR_SMP_1040_TITLE: 'SCR-SMP-1040.title',
  SCR_SMP_1040_PLACEHOLDER_CHEMICAL_FORMULA: 'SCR-SMP-1040.placeholderChemicalFormula',
  SCR_SMP_1100_TITLE: 'SCR-SMP-1100.title',
  SCR_SMP_1100_LABEL_OTHER_SAMPLE: 'SCR-SMP-1100.labelOtherSample',
  SCR_USR_1010_TITLE: 'SCR-USR-1010.title',
  SCR_USR_1010_FULL_NAME: 'SCR-USR-1010.fullName',
  SCR_USR_1010_ENGLISH_NAME: 'SCR-USR-1010.englishName',
  SCR_P_G_M_1010_TITLE_DATASET_SHARED_SETTING: 'SCR-PGM-1010.titleDatasetSharedSetting',
  SCR_P_G_M_1010_PLACEHOLDER_SELECT_PROGRAM: 'SCR-PGM-1010.placeholderSelectProgram',
  SCR_P_G_M_1010_NOT_SHARED: 'SCR-PGM-1010.notShared',
  SCR_P_G_M_1010_PLACEHOLDER_DATASET_NAME: 'SCR-PGM-1010.placeholderDatasetName',
  SCR_P_G_M_1010_SELECTED_SHARED: 'SCR-PGM-1010.selectedShared',
  SCR_P_G_M_1011_TITLE_SHARED_CONFIRMATION: 'SCR-PGM-1011.titleSharedConfirmation',
  SCR_P_G_M_1011_TITLE_UN_SHARED_CONFIRMATION: 'SCR-PGM-1011.titleUnSharedConfirmation'
};
